<div class="form-horizontal mt-3">
  <div class="row align-items-center pb-2 d-flex justify-content-between">
    <div
      class="col-sm-12 d-flex flex-md-row-reverse align-items-center justify-content-end justify-content-md-start justify-content-sm-end toolbar"
    >
      <div class="d-flex flex-md-row-reverse align-items-center">
        <div class="d-flex ml-auto ml-md-0">
          <button
            class="cdx-button cdx-button--icon cdx-button--lg"
            (click)="showAddResponsibleModal(modalAddResponsible)"
            ngbTooltip="{{ model.envelopeResponsible.length === 0 ? ('envelope.responsible.tooltip.addResponsible' | translate) : ('envelope.responsible.tooltip.changeResponsible' | translate) }}"
            placement="left"
          >
            <fa-icon class="fa-fw cdx-button__icon" [icon]="model.envelopeResponsible.length === 0 ? ['far', 'plus-circle'] : ['fas', 'exchange']"></fa-icon>
          </button>
        </div>
      </div>
      <div class="d-none d-lg-block">
          <span class="d-flex ml-auto">
            <cdx-toggle-switch class="mr-2" [toggledOn]="model.responsibleAccessAuthentication" (toggle)="onToggleAccessAuthentication($event)">
            </cdx-toggle-switch>
            {{'envelope.signatory.accessAuthentication' | translate}}
            <fa-icon ngbTooltip="{{'envelope.signatory.tooltip.accessAuthentication' | translate}}" placement="left"
              class="ml-1 mr-1" size="sm" [icon]="['fas','question-circle']">
            </fa-icon>
          </span>
        </div>
    </div>
  </div>
</div>

<div class="table-responsive pl-2 pr-2">
  <ng-container *ngIf="model.envelopeResponsible.length > 0; else blankSlateTable">
    <cdx-data-table [options]="dataTableOptions"></cdx-data-table>
  </ng-container>
</div>


<ng-template #blankSlateSearchTemplate>
  <ng-container>
    <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateSearchClick($event)">
      {{ 'envelope.responsible.blankSlateSearchText' | translate }}
    </cdx-blankslate>
  </ng-container>
</ng-template>

<ng-template #blankSlateTable>
  <ng-container *ngIf="searchText === ''; else blankSlateSearchTemplate">
    <div class="p-2 table__container">
      <cdx-blankslate [options]="blankSlate" (buttonClick)="showAddResponsibleModal(modalAddResponsible)">
        <span [innerHTML]="'envelope.responsible.blankSlateText' | translate"></span>
      </cdx-blankslate>
    </div>
  </ng-container>
</ng-template>

<ng-template #modalAddResponsible>
  <app-participant-modal
    (closeModalClick)="closeModalClick()"
    (submitModalClick)="submitAddModalClick($event)"
    [participantTypeInput]="participantType.Responsible"
    [enableEditContact]="true"
  >
  </app-participant-modal>
</ng-template>

<ng-template #confirmDeleteModal>
  <app-confirm-modal
    [HeaderText]="'envelope.responsible.confirm-disassociate-delete-modal.headerText'"
    [MessageText]="'envelope.responsible.confirm-disassociate-delete-modal.messageText'"
    (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()"
    [ButtonConfirmText]="'disassociateModalActions.remove'"
    [ButtonCancelText]="'disassociateModalActions.cancel'"
    [IsApprovalConfirm]="false"
    [modalIntentType]="modalIntentType.DANGER"
  >
  </app-confirm-modal>
</ng-template>
